import { h } from 'preact';

import LandingPageEditor from 'components/editor/movies/landing/landing';

import s from 'components/editor/movies/landing/landingFocus.sss';

export default class FocusLandingPageEditor extends LandingPageEditor {
	s = s;
}